import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { PlanModels } from 'src/app/models/plan_models';

@Injectable({
  providedIn: 'root'
})

export class PlanesService {

  baseUri = environment.URL_MULESOFT_ORQUESTADOR;
  // NOTA: TOKEN_MULESOFT eliminado - ahora se usa autenticación OAuth2 moderna

  constructor(private http: HttpClient) {
  }

  public getPlanesSura(): string {
    return JSON.stringify(
      [
        {
          "coverages": [
            {
              "price": {
                "formatted": "USD 35.000,00",
                "currency": "USD",
                "amount": 35000
              },
              "order": 1,
              "url": "https://condicionado.link",
              "description": "SURA coordinará y pagará los servicios médicos hasta USD 35.000 sin importar el lugar donde estés.",
              "name": "Gastos médicos"
            },
            {
              "price": {
                "formatted": "USD 8.000,00",
                "currency": "USD",
                "amount": 8000
              },
              "order": 2,
              "url": "https://condicionado.link",
              "description": "En caso de que se deba extender tu viaje y no puedas viajar a raíz de un accidente o enfermedad, cuentas con un monto de hasta 8.000 USD para asistencias como: gastos de hotel, gastos de desplazamiento y traslado, regreso de acompañante del asegurado y acompañamiento a mayores o menores.",
              "name": "Acompañamiento de viaje"
            },
            {
              "price": {
                "formatted": "USD 10.000,00",
                "currency": "USD",
                "amount": 10000
              },
              "order": 3,
              "url": "https://condicionado.link",
              "description": "Por la compra de tu plan, SURA te regala esta cobertura sin añadir costo adicional a tu pago. Por muerte accidental o si sufres una invalidez, pérdida o inutilización de una parte de tu cuerpo, SURA pagará hasta 10.000 USD.",
              "name": "Accidentes personales"
            }
          ],
          "total_insured_value": {
            "formatted": "USD 63.000,00",
            "currency": "USD",
            "amount": 63000
          },
          "price": {
            "full": {
              "formatted": "COP 400.000,00",
              "currency": "COP",
              "amount": 400000
            }
          },
          "order": 1,
          "code": "VIAJES_PlanEsencial",
          "name": "Esencial"
        },
        {
          "coverages": [
            {
              "price": {
                "formatted": "USD 50.000,00",
                "currency": "USD",
                "amount": 50000
              },
              "order": 1,
              "url": "https://condicionado.link",
              "description": "SURA coordinará y pagará los servicios médicos hasta USD 35.000 sin importar el lugar donde estés.",
              "name": "Gastos médicos"
            },
            {
              "price": {
                "formatted": "USD 8.000,00",
                "currency": "USD",
                "amount": 8000
              },
              "order": 2,
              "url": "https://condicionado.link",
              "description": "En caso de que se deba extender tu viaje y no puedas viajar a raíz de un accidente o enfermedad, cuentas con un monto de hasta 8.000 USD para asistencias como: gastos de hotel, gastos de desplazamiento y traslado, regreso de acompañante del asegurado y acompañamiento a mayores o menores.",
              "name": "Acompañamiento de viaje"
            },
            {
              "price": {
                "formatted": "USD 200,00",
                "currency": "USD",
                "amount": 200
              },
              "order": 3,
              "url": "https://condicionado.link",
              "description": "En caso de que tu aerolínea cancele o si pierdes un vuelo por causas ajenas a tu voluntad, SURA te pagará el valor asegurado hasta por 200 USD.",
              "name": "Cancelación del viaje y perdida de vuelo por conexión"
            },
            {
              "price": {
                "formatted": "USD 10.000,00",
                "currency": "USD",
                "amount": 10000
              },
              "order": 4,
              "url": "https://condicionado.link",
              "description": "Por la compra de tu plan, SURA te regala esta cobertura sin añadir costo adicional a tu pago. Por muerte accidental o si sufres una invalidez, pérdida o inutilización de una parte de tu cuerpo, SURA pagará hasta 10.000 USD.",
              "name": "Accidentes personales"
            }
          ],
          "total_insured_value": {
            "formatted": "USD 78.000,00",
            "currency": "USD",
            "amount": 78000
          },
          "price": {
            "full": {
              "formatted": "COP 500.000,00",
              "currency": "COP",
              "amount": 500000
            }
          },
          "order": 2,
          "code": "VIAJES_PlanPlus",
          "name": "Plus"
        },
        {
          "coverages": [
            {
              "price": {
                "formatted": "USD 75.000,00",
                "currency": "USD",
                "amount": 75000
              },
              "order": 1,
              "url": "https://condicionado.link",
              "description": "SURA coordinará y pagará los servicios médicos hasta USD 35.000 sin importar el lugar donde estés.",
              "name": "Gastos médicos"
            },
            {
              "price": {
                "formatted": "USD 200,00",
                "currency": "USD",
                "amount": 200
              },
              "order": 2,
              "url": "https://condicionado.link",
              "description": "En caso de robo durante tu viaje, te indemnizamos el valor de los gastos que hayas asumido para reponer los documentos hasta por 200 USD.",
              "name": "Hurto de documentos en viaje"
            },
            {
              "price": {
                "formatted": "USD 8.000,00",
                "currency": "USD",
                "amount": 8000
              },
              "order": 3,
              "url": "https://condicionado.link",
              "description": "En caso de que se deba extender tu viaje y no puedas viajar a raíz de un accidente o enfermedad, cuentas con un monto de hasta 8.000 USD para asistencias como: gastos de hotel, gastos de desplazamiento y traslado, regreso de acompañante del asegurado y acompañamiento a mayores o menores.",
              "name": "Acompañamiento de viaje"
            },
            {
              "price": {
                "formatted": "USD 300,00",
                "currency": "USD",
                "amount": 300
              },
              "order": 4,
              "url": "https://condicionado.link",
              "description": "En caso de que tu aerolínea cancele o si pierdes un vuelo por causas ajenas a tu voluntad, SURA te pagará el valor asegurado hasta por 200 USD.",
              "name": "Cancelación dew viaje y perdida de vuelo por conexión"
            },
            {
              "price": {
                "formatted": "USD 10.000,00",
                "currency": "USD",
                "amount": 10000
              },
              "order": 5,
              "url": "https://condicionado.link",
              "description": "Por la compra de tu plan, SURA te regala esta cobertura sin añadir costo adicional a tu pago. Por muerte accidental o si sufres una invalidez, pérdida o inutilización de una parte de tu cuerpo, SURA pagará hasta 10.000 USD.",
              "name": "Accidentes personales"
            }
          ],
          "total_insured_value": {
            "formatted": "USD 104.000,00",
            "currency": "USD",
            "amount": 104000
          },
          "price": {
            "full": {
              "formatted": "COP 600.000,00",
              "currency": "COP",
              "amount": 600000
            }
          },
          "order": 3,
          "code": "VIAJES_PlanTotal",
          "name": "Total"
        }
      ]
    );
  }

  public getPlanesAlterno(): PlanModels {
    return JSON.parse(
      JSON.stringify(
        {
          "plans": [
            {
              "isMaxLimit": false,
              "price": {
                "full": {
                  "currency": "COP",
                  "amount": 0.00,
                  "formatted": "COP 0,00"
                }
              },
              "total_insured_value": {
                "currency": "USD",
                "amount": 63000.00,
                "formatted": "USD 63.000,00"
              },
              "coverages": [
                {
                  "price": {
                    "formatted": "USD 8.000,00",
                    "currency": "USD",
                    "amount": 8000.00
                  },
                  "order": "2",
                  "url": "SURA.COM",
                  "description": "En caso de que se deba extender su viaje y no puedas viajar a raiz de accidente o enfermedad, cuentas con un monto de hasta 8.000 USD para asistencias como: gastos de hotel, gastos de desplazamiento y traslado, regreso del acompañante del asegurado y acompañamiento a mayores o menores",
                  "name": "Acompañamiento de viaje"
                },
                {
                  "price": {
                    "formatted": "USD 10.000,00",
                    "currency": "USD",
                    "amount": 10000.00
                  },
                  "order": "6",
                  "url": "SURA.COM",
                  "description": "Por muerte accidental o si sufres una invalidez, pérdida o inutilización de una parte de tu cuerpo, SURA pagará hasta 10.000 USD",
                  "name": "Accidentes personales"
                },
                {
                  "price": {
                    "formatted": "USD 35.000,00",
                    "currency": "USD",
                    "amount": 35000.00
                  },
                  "order": "1",
                  "url": "SURA.COM",
                  "description": "SURA Coordinará y pagará los servicios médicos hasta 75.000 USD sin importar el lugar donde estés",
                  "name": "Gastos médicos Internacional"
                }
              ],
              "productId": "01tD6000008eLxkIAE",
              "productCode": "VIAJES_PlanEsencial",
              "name": "Plan Esencial Viajes Internacional"
            },
            {
              "isMaxLimit": false,
              "price": {
                "full": {
                  "currency": "COP",
                  "amount": 0.00,
                  "formatted": "COP 0,00"
                }
              },
              "total_insured_value": {
                "currency": "USD",
                "amount": 78200.00,
                "formatted": "USD 78.200,00"
              },
              "coverages": [
                {
                  "price": {
                    "formatted": "USD 50.000,00",
                    "currency": "USD",
                    "amount": 50000.00
                  },
                  "order": "1",
                  "url": "SURA.COM",
                  "description": "SURA Coordinará y pagará los servicios médicos hasta 75.000 USD sin importar el lugar donde estés",
                  "name": "Gastos médicos Internacional"
                },
                {
                  "price": {
                    "formatted": "USD 8.000,00",
                    "currency": "USD",
                    "amount": 8000.00
                  },
                  "order": "2",
                  "url": "SURA.COM",
                  "description": "En caso de que se deba extender su viaje y no puedas viajar a raiz de accidente o enfermedad, cuentas con un monto de hasta 8.000 USD para asistencias como: gastos de hotel, gastos de desplazamiento y traslado, regreso del acompañante del asegurado y acompañamiento a mayores o menores",
                  "name": "Acompañamiento de viaje"
                },
                {
                  "price": {
                    "formatted": "USD 200,00",
                    "currency": "USD",
                    "amount": 200.00
                  },
                  "order": "5",
                  "url": "SURA.COM",
                  "description": "En caso de que tu aereolinea cancele o si pierdes un vuelo por causas ajenas a tu voluntad, SURA pagará el valor asegurado hasta 300 USD",
                  "name": "Cancelación de viaje y perdida de vuelo por conexión"
                },
                {
                  "price": {
                    "formatted": "USD 10.000,00",
                    "currency": "USD",
                    "amount": 10000.00
                  },
                  "order": "6",
                  "url": "SURA.COM",
                  "description": "Por muerte accidental o si sufres una invalidez, pérdida o inutilización de una parte de tu cuerpo, SURA pagará hasta 10.000 USD",
                  "name": "Accidentes personales"
                }
              ],
              "productId": "01tD6000008eLvUIAU",
              "productCode": "VIAJES_PlanPlus",
              "name": "Plan Plus Viajes Internacional"
            },
            {
              "isMaxLimit": false,
              "price": {
                "full": {
                  "currency": "COP",
                  "amount": 0.00,
                  "formatted": "COP 0,00"
                }
              },
              "total_insured_value": {
                "currency": "USD",
                "amount": 104000.00,
                "formatted": "USD 104.000,00"
              },
              "coverages": [
                {
                  "price": {
                    "formatted": "USD 300,00",
                    "currency": "USD",
                    "amount": 300.00
                  },
                  "order": "5",
                  "url": "SURA.COM",
                  "description": "En caso de que tu aereolinea cancele o si pierdes un vuelo por causas ajenas a tu voluntad, SURA pagará el valor asegurado hasta 300 USD",
                  "name": "Cancelación de viaje y perdida de vuelo por conexión"
                },
                {
                  "price": {
                    "formatted": "USD 500,00",
                    "currency": "USD",
                    "amount": 500.00
                  },
                  "order": "4",
                  "url": "SURA.COM",
                  "description": "En caso de retraso o perdida de tu equipaje, te indemnizamos con el moto contratado (500 USD). *Cuando ocurre retraso de equipaje, la indemnización es inmediata",
                  "name": "Equipaje protegido"
                },
                {
                  "price": {
                    "formatted": "USD 50.000,00",
                    "currency": "USD",
                    "amount": 50000.00
                  },
                  "order": "1",
                  "url": "SURA.COM",
                  "description": "SURA Coordinará y pagará los servicios médicos hasta 75.000 USD sin importar el lugar donde estés",
                  "name": "Gastos médicos Internacional"
                },
                {
                  "price": {
                    "formatted": "USD 8.000,00",
                    "currency": "USD",
                    "amount": 8000.00
                  },
                  "order": "2",
                  "url": "SURA.COM",
                  "description": "En caso de que se deba extender su viaje y no puedas viajar a raiz de accidente o enfermedad, cuentas con un monto de hasta 8.000 USD para asistencias como: gastos de hotel, gastos de desplazamiento y traslado, regreso del acompañante del asegurado y acompañamiento a mayores o menores",
                  "name": "Acompañamiento de viaje"
                },
                {
                  "price": {
                    "formatted": "USD 200,00",
                    "currency": "USD",
                    "amount": 200.00
                  },
                  "order": "3",
                  "url": "SURA.COM",
                  "description": "En caso de robo durante tu viaje, te indemnizamos el valor de los gastos que hayas asumido para reponer los documentos hasta 200 USD",
                  "name": "Hurto de documento de viaje"
                },
                {
                  "price": {
                    "formatted": "USD 10.000,00",
                    "currency": "USD",
                    "amount": 10000.00
                  },
                  "order": "6",
                  "url": "SURA.COM",
                  "description": "Por muerte accidental o si sufres una invalidez, pérdida o inutilización de una parte de tu cuerpo, SURA pagará hasta 10.000 USD",
                  "name": "Accidentes personales"
                }
              ],
              "productId": "01tD6000008eLw3IAE",
              "productCode": "VIAJES_PlanTotal",
              "name": "Plan Total Viajes Internacional"
            }
          ]
        }
      )
    )
  }

  public getPlanes(sessionId: string, idLead: string, idViaje: string): Observable<PlanModels> {
    // NOTA: JWT legacy eliminado - El headers de autenticación se maneja automáticamente por interceptors
    let headers = new HttpHeaders({
      'Accept': '*/*',
      'SESSION_ID': sessionId,
      // 'jwt': eliminado - sistema de autenticación moderno via interceptors
    });

    return this.http.get<PlanModels>(this.baseUri.concat('/').concat(idLead).concat('/').concat(idViaje), { headers: headers })
  }
}
